import styles from "./page404.module.scss";

export const Page404 = () => {
  const errorMessage = "Запрашиваемая страница не существует";

  const back = () => {
    // eslint-disable-next-line no-restricted-globals
    history.go(-2);
  };

  return (
    <div className={styles.main}>
      <div className={styles.container}>
        <h1 className={styles.title}>404</h1>
        <p>
          <i className={styles.message}>{errorMessage}</i>
        </p>
        <button className={styles.button} onClick={back}>
          Назад
        </button>
      </div>
    </div>
  );
};
